import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=edf58680&scoped=true&"
import script from "./Upsert.vue?vue&type=script&lang=js&"
export * from "./Upsert.vue?vue&type=script&lang=js&"
import style0 from "./Upsert.vue?vue&type=style&index=0&id=edf58680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf58680",
  null
  
)

export default component.exports